var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "MultiInputFields"
  }, [_vm._l(_vm.fields, function (field, index) {
    return _c('div', {
      key: ("field_" + index),
      staticClass: "MultiInputFields-fieldContainer",
      class: {
        'MultiInputFields-fieldContainer--last': _vm.isLast(index)
      }
    }, [_c('input-field-with-label', {
      staticClass: "MultiInputFields-field",
      attrs: {
        "label": field.label
      },
      model: {
        value: field.value,
        callback: function ($$v) {
          _vm.$set(field, "value", $$v);
        },
        expression: "field.value"
      }
    }), _c('button', {
      staticClass: "MultiInputFields-removeButton",
      attrs: {
        "aria-label": _vm.$t('button.removeField'),
        "type": "button"
      },
      on: {
        "click": function ($event) {
          return _vm.removeField(index);
        },
        "keyup": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.removeField(index);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          return _vm.removeField(index);
        }]
      }
    }, [_c('i', {
      staticClass: "cfih-cross"
    })])], 1);
  }), _vm.isButtonNeeded ? _c('div', {
    staticClass: "MultiInputFields-buttonContainer",
    class: {
      'MultiInputFields-buttonContainer--withoutField': _vm.fieldsEmpty
    }
  }, [_c('rounded-button', {
    attrs: {
      "label": _vm.getAddLabel,
      "type": 'reversed'
    },
    on: {
      "buttonClicked": _vm.addField
    }
  })], 1) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }